export default __webpack_public_path__ + "static/media/filters.b125571e.svg";